import { render, staticRenderFns } from "./UserListings.vue?vue&type=template&id=528a83bb"
import script from "./UserListings.vue?vue&type=script&lang=js"
export * from "./UserListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports